/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { bodyPreview } from 'my-phorest/utils/whatsapp';
import { task } from 'ember-concurrency';

export default class TwoWayChatTemplatePreviewComponent extends Component {
  @service twoWayChat;

  get templatePreview() {
    return bodyPreview(this.twoWayChat.selectedTemplate.structure.body.text);
  }

  @task
  *sendTemplate() {
    yield this.twoWayChat.sendTemplateTask.perform();
    yield this.twoWayChat.setScreenTask.perform('client-chat');
  }
}
